<template>
  <div v-if="message" :class="['custom-alert', type]">
    <div class="alert-icon">
      <!-- Success Icon -->
      <svg v-if="type === 'success'" stroke="currentColor" viewBox="0 0 24 24" fill="none" class="icon-svg" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 16h-1v-4h1m0-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"></path>
      </svg>
      <!-- Info Icon -->
      <svg v-else-if="type === 'info'" stroke="currentColor" viewBox="0 0 24 24" fill="none" class="icon-svg" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 16h-1v-4h1m0-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"></path>
      </svg>
      <!-- Warning Icon -->
      <svg v-else-if="type === 'warning'" stroke="currentColor" viewBox="0 0 24 24" fill="none" class="icon-svg" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 16h-1v-4h1m0-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"></path>
      </svg>
      <!-- Error Icon -->
      <svg v-else stroke="currentColor" viewBox="0 0 24 24" fill="none" class="icon-svg" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 16h-1v-4h1m0-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"></path>
      </svg>
    </div>
    <div class="alert-content">
      <p class="alert-text">
        <span class="alert-title">{{ defaultTitle }} - </span>
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomAlert',
  props: {
    message: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'error',
      validator: (value) => ['success', 'info', 'warning', 'error'].includes(value),
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    defaultTitle() {
      if (this.title) return this.title;
      switch (this.type) {
        case 'success': return 'Éxito';
        case 'info': return 'Info';
        case 'warning': return 'Advertencia';
        case 'error': return 'Error';
        default: return 'Aviso';
      }
    },
  },
};
</script>

<style scoped>
.custom-alert {
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
  border-left: 4px solid;
  transition: all 0.3s ease-in-out;
  animation: slideInDown 0.3s ease-out forwards;
}

.custom-alert:hover {
  transform: scale(1.01);
}

@keyframes slideInDown {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.icon-svg {
  height: 20px;
  width: 20px;
  flex-shrink: 0;
  margin-right: 12px;
}

.alert-content {
  display: flex;
  flex-direction: column;
}

.alert-text {
  font-size: 13px;
  font-weight: 600;
  margin: 0;
}

.alert-title {
  font-weight: bold;
}

/* Success */
.custom-alert.success {
  background-color: rgba(22, 163, 74, 0.15);
  border-left-color: #16a34a;
  color: #15803d;
}
.dark .custom-alert.success {
  background-color: #14532d;
  border-left-color: #15803d;
  color: #dcfce7;
}
.custom-alert.success .icon-svg {
  color: #16a34a;
}

/* Info */
.custom-alert.info {
  background-color: rgba(37, 99, 235, 0.15);
  border-left-color: #2563eb;
  color: #1d4ed8;
}
.dark .custom-alert.info {
  background-color: #1e3a8a;
  border-left-color: #1d4ed8;
  color: #dbeafe;
}
.custom-alert.info .icon-svg {
  color: #2563eb;
}

/* Warning */
.custom-alert.warning {
  background-color: rgba(202, 138, 4, 0.15);
  border-left-color: #ca8a04;
  color: #a16207;
}
.dark .custom-alert.warning {
  background-color: #713f12;
  border-left-color: #a16207;
  color: #fef9c3;
}
.custom-alert.warning .icon-svg {
  color: #ca8a04;
}

/* Error */
.custom-alert.error {
  background-color: rgba(220, 38, 38, 0.15);
  border-left-color: #dc2626;
  color: #b91c1c;
}
.dark .custom-alert.error {
  background-color: #7f1d1d;
  border-left-color: #b91c1c;
  color: #fee2e2;
}
.custom-alert.error .icon-svg {
  color: #dc2626;
}
</style>
